import React from 'react'

function AboutUsPage() {
  return (
    <main>
        <div className="main_section_1_img_wrapper">
            <img src={require("./static/img/trucks.jpg")} alt="" />
            <h2 className="blur_div">
                &nbsp;
                “MARYAWTOULAG” <br />
                ÖNÜMÇILIK BIRLEŞIGI
                <img src={require("./static/img/arrow_down.png")} alt="" />
            </h2>
        </div>


        <div className="about_us_section_2">
            <h2>Biz hakda</h2>
            <img src={require("./static/img/element2.png")} alt="" />
        </div>

        <div className="about_us_section_3">
            <div className="about_us_grid_wrapper">
                <div className="about_us_grid_1">
                    <p className="quote">
                        <span className="title">Türkmenistanyň Prezidenti Gurbanguly Berdimuhamedow:</span>
                        <span className="paragraph_1">“Sebitde köpugurly ulag geçelgeleriniň döredilmegi sebitiň ägirt uly 
                            ykdysady mümkinçiliklerini amala aşyrmaga, şonuň bilen birlikde 
                            parahatçylygy, durnuklylygy we howpsuzlygy berkitmäge, ählumumy 
                            durmuş-ykdysady ösüşe ýardam eder”.</span>
                        <br />
                    
                        <span className="paragraph_2">“Türkmenawtoulaglary” agentliginiň 2020-nji ýylyň 31-nji 
                        martyndaky çykaran 33-Ö belgili buýrugy esasynda gaýtadan 
                        bellige alynan kärhanadyr. “Maryawtoulag” önümçilik birleşigi öz işini 
                        Türkmenistanyň “Kärhanalar hakyndaky” kanuny, Zähmet hakyndaky 
                        kanunlara we beýleki hereket edýän kanunçylyk hukuknamalaryna, 
                        “Türkmenawtoulaglary” agentliginiň buýruklaryna we 
                        görkezmelerine, Birleşigiň tertipnamasyna laýyklykda alyp barýar.</span>
                    </p>
                </div>
                <div className="about_us_grid_2">
                    <img src={require("./static/img/cont.jpg")} alt="" />
                </div>

                <div className="about_us_grid_3">
                    <img src={require("./static/img/about.jpg")} alt="" />
                </div>

                <div className="about_us_grid_4">
                    <div className="paragraph_wrapper">
                        <p>
                            Birleşik Türkmenistanyň Maliýe we ykdysadyýet ministrliginiň Ýuridiki 
                            şahslary we maýa goýum taslamalary döwlet tarapyndan bellige almak 
                            bölümi tarapyndan 2020-nji ýylyň mart aýynyň 7-ne 25793297 belgi bilen 
                            gaýtadan bellige alynan “Türkmenawtoulaglary” agentliginiň 
                            tabynlygyndaky kärhanasydyr. Birleşik ilki başda Mary welaýatynyň 
                            statistika uprawleniýasy tarapyndan 85458 belgili şertnama bilen 1994-nji 
                            ýylyň ýanwar aýynyň 31-ne Marynyň pudagara “Maryawtotranssowhoz” 
                            birleşigi ady bilen hasaba alyndy.
                        
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </main>
  )
}

export default AboutUsPage